import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("h5", { class: "mb-0" }, "Eksporterer logs", -1)
const _hoisted_2 = { class: "mb-2" }
const _hoisted_3 = { class: "mb-0 text-muted" }
const _hoisted_4 = { class: "appension" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Vi fandt ")
const _hoisted_7 = { class: "text-primary" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" logs ")
const _hoisted_9 = { class: "filters bg-white rounded p-3 mb-3" }
const _hoisted_10 = { class: "row mt-3" }
const _hoisted_11 = { class: "col-md-4" }
const _hoisted_12 = { class: "col-md-4" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "col-md-4" }, null, -1)
const _hoisted_14 = { class: "row mt-3" }
const _hoisted_15 = { class: "col-md-4" }
const _hoisted_16 = /*#__PURE__*/_createVNode("label", { style: {"margin-bottom":"5px"} }, "Niveau", -1)
const _hoisted_17 = { class: "col-md-4" }
const _hoisted_18 = /*#__PURE__*/_createVNode("label", { style: {"margin-bottom":"5px"} }, "Type", -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("div", { class: "col-md-4" }, null, -1)
const _hoisted_20 = { class: "row mt-3" }
const _hoisted_21 = { class: "col-md-4" }
const _hoisted_22 = /*#__PURE__*/_createVNode("label", { style: {"margin-bottom":"5px"} }, "Organisation", -1)
const _hoisted_23 = { class: "col-md-4" }
const _hoisted_24 = /*#__PURE__*/_createVNode("label", { style: {"margin-bottom":"5px"} }, "Applikation", -1)
const _hoisted_25 = { class: "col-md-4" }
const _hoisted_26 = /*#__PURE__*/_createVNode("label", { style: {"margin-bottom":"5px"} }, "Begivenhed", -1)
const _hoisted_27 = { class: "row mt-3" }
const _hoisted_28 = { class: "col-12 text-end" }
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" Anvend filtre ")
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" Nulstil ")
const _hoisted_31 = { class: "d-flex" }
const _hoisted_32 = { class: "d-flex" }
const _hoisted_33 = {
  class: "text-truncate",
  style: {"max-width":"300px"}
}
const _hoisted_34 = { class: "d-flex" }
const _hoisted_35 = { class: "d-flex" }
const _hoisted_36 = { class: "d-flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_app_header = _resolveComponent("app-header")!
  const _component_error = _resolveComponent("error")!
  const _component_o_datepicker = _resolveComponent("o-datepicker")!
  const _component_o_field = _resolveComponent("o-field")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_Log = _resolveComponent("Log")!
  const _component_page = _resolveComponent("page")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_router_view),
    _createVNode(_component_Dialog, {
      visible: _ctx.isExporting,
      closable: false,
      draggable: false,
      modal: true
    }, {
      header: _withCtx(() => [
        _hoisted_1
      ]),
      default: _withCtx(() => [
        _createVNode("p", _hoisted_2, " Henter logs " + _toDisplayString(_ctx.batchFrom) + "-" + _toDisplayString(_ctx.exportedCount) + " af " + _toDisplayString(_ctx.logs.total) + " - venter på server… ", 1),
        _createVNode("p", _hoisted_3, [
          _createVNode("span", null, " Færdig med at hente " + _toDisplayString(_ctx.finishedCount) + " af " + _toDisplayString(_ctx.logs.total), 1)
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_page, { isLoading: _ctx.loading }, {
      default: _withCtx(() => [
        (_ctx.logs && _ctx.applications && _ctx.organizations && _ctx.events)
          ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
              _createVNode("div", _hoisted_4, [
                _createVNode(_component_app_header, {
                  titleButtonIcon: undefined,
                  canSearch: false,
                  title: 'Logs'
                }, {
                  subtitle: _withCtx(() => [
                    (_ctx.logs)
                      ? (_openBlock(), _createBlock("strong", _hoisted_5, [
                          _hoisted_6,
                          _createVNode("span", _hoisted_7, _toDisplayString(_ctx.logs.total), 1),
                          _hoisted_8
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode("div", _hoisted_9, [
                  (_ctx.yearRangeError)
                    ? (_openBlock(), _createBlock(_component_error, {
                        key: 0,
                        error: _ctx.yearRangeError
                      }, null, 8, ["error"]))
                    : _createCommentVNode("", true),
                  _createVNode("div", _hoisted_10, [
                    _createVNode("div", _hoisted_11, [
                      _createVNode(_component_o_field, { label: "Fra dato" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_o_datepicker, {
                            modelValue: _ctx.filters.fromDate,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filters.fromDate = $event)),
                            "close-on-click": _ctx.closeDatePickerOnSelect.fromDate,
                            "min-date": _ctx.yearBounds?.minDate,
                            "max-date": _ctx.yearBounds?.maxDate,
                            "years-range": _ctx.yearBounds?.yearsRange,
                            "focused-date": _ctx.filters.fromDate,
                            disabled: 
                    _ctx.yearRangeLoading || !_ctx.yearBounds || !!_ctx.yearRangeError
                  ,
                            onChangeMonth: _cache[2] || (_cache[2] = ($event: any) => (_ctx.updateDatePart('fromDate', 'month', $event))),
                            onChangeYear: _cache[3] || (_cache[3] = ($event: any) => (_ctx.updateDatePart('fromDate', 'year', $event))),
                            placeholder: "Vælg fra dato",
                            "date-formatter": 
                    (date) => (date ? date.toLocaleDateString('da-DK') : '')
                  
                          }, null, 8, ["modelValue", "close-on-click", "min-date", "max-date", "years-range", "focused-date", "disabled", "date-formatter"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createVNode("div", _hoisted_12, [
                      _createVNode(_component_o_field, { label: "Til dato" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_o_datepicker, {
                            modelValue: _ctx.filters.toDate,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.filters.toDate = $event)),
                            "close-on-click": _ctx.closeDatePickerOnSelect.toDate,
                            "min-date": _ctx.yearBounds?.minDate,
                            "max-date": _ctx.yearBounds?.maxDate,
                            "years-range": _ctx.yearBounds?.yearsRange,
                            "focused-date": _ctx.filters.toDate,
                            disabled: 
                    _ctx.yearRangeLoading || !_ctx.yearBounds || !!_ctx.yearRangeError
                  ,
                            onChangeMonth: _cache[5] || (_cache[5] = ($event: any) => (_ctx.updateDatePart('toDate', 'month', $event))),
                            onChangeYear: _cache[6] || (_cache[6] = ($event: any) => (_ctx.updateDatePart('toDate', 'year', $event))),
                            placeholder: "Vælg til dato",
                            "date-formatter": 
                    (date) => (date ? date.toLocaleDateString('da-DK') : '')
                  
                          }, null, 8, ["modelValue", "close-on-click", "min-date", "max-date", "years-range", "focused-date", "disabled", "date-formatter"])
                        ]),
                        _: 1
                      })
                    ]),
                    _hoisted_13
                  ]),
                  _createVNode("div", _hoisted_14, [
                    _createVNode("div", _hoisted_15, [
                      _hoisted_16,
                      _createVNode(_component_Dropdown, {
                        modelValue: _ctx.filters.level,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.filters.level = $event)),
                        options: [
                  { label: 'Alle', value: '' },
                  { label: 'Fejl', value: 'Error' },
                  { label: 'Advarsel', value: 'Warning' },
                  { label: 'Information', value: 'Information' },
                ],
                        optionLabel: "label",
                        optionValue: "value",
                        placeholder: "Vælg niveau",
                        class: "p-custom-dropdown d-flex",
                        style: {"margin-left":"unset"}
                      }, null, 8, ["modelValue"])
                    ]),
                    _createVNode("div", _hoisted_17, [
                      _hoisted_18,
                      _createVNode(_component_Dropdown, {
                        modelValue: _ctx.filters.type,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.filters.type = $event)),
                        options: [
                  { label: 'Alle', value: '' },
                  { label: 'Sikkerhed', value: 'Security' },
                  { label: 'Revision', value: 'Revision' },
                ],
                        optionLabel: "label",
                        optionValue: "value",
                        placeholder: "Vælg type",
                        class: "p-custom-dropdown d-flex",
                        style: {"margin-left":"unset"}
                      }, null, 8, ["modelValue"])
                    ]),
                    _hoisted_19
                  ]),
                  _createVNode("div", _hoisted_20, [
                    _createVNode("div", _hoisted_21, [
                      _hoisted_22,
                      _createVNode(_component_MultiSelect, {
                        id: "organizations",
                        class: "d-flex",
                        modelValue: _ctx.selectedOrganizations,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.selectedOrganizations = $event)),
                        options: _ctx.organizations,
                        optionLabel: "name",
                        optionValue: "organizationId",
                        placeholder: "Vælg organisation",
                        filter: true,
                        showToggleAll: true
                      }, null, 8, ["modelValue", "options"])
                    ]),
                    _createVNode("div", _hoisted_23, [
                      _hoisted_24,
                      _createVNode(_component_MultiSelect, {
                        id: "applications",
                        class: "d-flex",
                        modelValue: _ctx.selectedApplications,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.selectedApplications = $event)),
                        options: _ctx.applications,
                        optionLabel: "name",
                        optionValue: "applicationId",
                        placeholder: "Vælg applications",
                        filter: true,
                        showToggleAll: true
                      }, null, 8, ["modelValue", "options"])
                    ]),
                    _createVNode("div", _hoisted_25, [
                      _hoisted_26,
                      _createVNode(_component_MultiSelect, {
                        id: "events",
                        class: "d-flex",
                        modelValue: _ctx.selectedEvents,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.selectedEvents = $event)),
                        options: _ctx.events,
                        optionLabel: "description",
                        optionValue: "id",
                        placeholder: "Vælg begivenhed",
                        filter: true,
                        showToggleAll: true
                      }, null, 8, ["modelValue", "options"])
                    ])
                  ]),
                  _createVNode("div", _hoisted_27, [
                    _createVNode("div", _hoisted_28, [
                      _createVNode(_component_Button, {
                        onClick: _ctx.applyFilters,
                        class: "primary ms-2",
                        disabled: _ctx.isFiltering
                      }, {
                        default: _withCtx(() => [
                          (_ctx.isFiltering)
                            ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                key: 0,
                                icon: ['fas', 'spinner'],
                                spin: "",
                                size: "lg",
                                class: "me-2"
                              }))
                            : _createCommentVNode("", true),
                          _hoisted_29
                        ]),
                        _: 1
                      }, 8, ["onClick", "disabled"]),
                      _createVNode(_component_Button, {
                        onClick: _ctx.resetFilters,
                        class: "primary ms-2"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_30
                        ]),
                        _: 1
                      }, 8, ["onClick"]),
                      _withDirectives(_createVNode(_component_Button, {
                        onClick: _ctx.exportLogsToExcel,
                        class: "primary ms-2",
                        disabled: !_ctx.logs?.items?.length || _ctx.isExporting
                      }, {
                        default: _withCtx(() => [
                          (_ctx.isExporting)
                            ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                key: 0,
                                icon: ['fas', 'spinner'],
                                spin: "",
                                size: "lg",
                                class: "me-2 ms-2"
                              }))
                            : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                key: 1,
                                icon: ['fas', 'file-excel'],
                                size: "lg",
                                class: "me-2 ms-2"
                              }))
                        ]),
                        _: 1
                      }, 8, ["onClick", "disabled"]), [
                        [
                          _directive_tooltip,
                          'Eksporter til Excel',
                          void 0,
                          { top: true }
                        ]
                      ])
                    ])
                  ])
                ]),
                _createVNode(_component_DataTable, {
                  sortField: "timestamp",
                  sortOrder: -1,
                  responsiveLayout: "scroll",
                  dataKey: "id",
                  value: _ctx.logs?.items ?? [],
                  class: "logs bg-white rounded",
                  selectionMode: "single",
                  onRowClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.logSidebar.showLogSidebar($event.data)))
                }, {
                  empty: _withCtx(() => [
                    _createVNode(_component_error, { error: {
                title: 'Ingen logs',
                message: 'Der er ikke nogle logs registreret endnu',
              } })
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_Column, {
                      field: "level",
                      header: "Niveau"
                    }, {
                      body: _withCtx((slotProps) => [
                        _createVNode("div", _hoisted_31, [
                          _createVNode("span", {
                            class: {
                    'text-danger': slotProps.data.level === 'Error',
                  }
                          }, _toDisplayString(slotProps.data.level), 3)
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, {
                      field: "message",
                      header: "Begivenhed"
                    }, {
                      body: _withCtx((slotProps) => [
                        _createVNode("div", _hoisted_32, [
                          _withDirectives(_createVNode("span", _hoisted_33, [
                            _createTextVNode(_toDisplayString(slotProps.data.eventDescription), 1)
                          ], 512), [
                            [
                              _directive_tooltip,
                              slotProps.data.eventDescription,
                              void 0,
                              { top: true }
                            ]
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, {
                      field: "organizationName",
                      header: "Organisation"
                    }, {
                      body: _withCtx((slotProps) => [
                        _createVNode("div", _hoisted_34, [
                          _createVNode("span", null, _toDisplayString(slotProps.data.organizationName || "-"), 1)
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, {
                      field: "applicationName",
                      header: "Applikation"
                    }, {
                      body: _withCtx((slotProps) => [
                        _createVNode("div", _hoisted_35, [
                          _createVNode("span", null, _toDisplayString(slotProps.data.applicationName || "-"), 1)
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, {
                      field: "timestamp",
                      header: "Tidsstempel (UTC)"
                    }, {
                      body: _withCtx((slotProps) => [
                        _createVNode("div", _hoisted_36, [
                          _createVNode("span", null, _toDisplayString(_ctx.displayUTCTimestamp(slotProps.data.timestamp)), 1)
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"]),
                _createVNode(_component_Pagination, {
                  rows: _ctx.pageParams.pageSize,
                  totalRecords: _ctx.logs.total,
                  page: _ctx.pageParams.currentPage! - 1,
                  onPageChange: _ctx.onPageChange
                }, null, 8, ["rows", "totalRecords", "page", "onPageChange"])
              ]),
              (_ctx.logSidebar.selectedLog.value)
                ? (_openBlock(), _createBlock(_component_Log, {
                    key: 0,
                    id: _ctx.logSidebar.selectedLog?.value?.id,
                    onHide: _ctx.logSidebar.hideLogSidebar
                  }, null, 8, ["id", "onHide"]))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["isLoading"])
  ], 64))
}